export default {
  APP_NAME: "Project Sakura | Downloads",
  APP_SUBNAME: "Project Sakura ",
  APP_DESC: "Project Sakura download page for official devices",
  APP_LOGO: "/img/logo.png",
};
